import { ReactComponent as SearchIcon } from "assets/svgs/search/Search.svg";

const SearchBar = ({ className = "", value, onChange = () => { }, onClick = () => { } }) => {
    return (
        <div
            className={`flex  items-center justify-between rounded-r3 bg-black70 px-2 py-1 ${className}`}
        >
            <input
                className="text-h5 m-auto w-full text-white"
                type="text"
                placeholder="Search..."
                value={value}
                onChange={onChange}
            />
            <SearchIcon className={`${onClick && "cursor-pointer"} w-3`} onClick={onClick} />
        </div>
    );
};

export default SearchBar;
